export default "__VITE_ASSET__Y4r5PSgl__"